'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { fetchReferences } from '@eliadmin/core/src/api/references/references-api';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { ReferenceCardHover } from './reference-card-hover';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const ReferencesList = () => {
  const locale = useLocaleStore(s => s.currentLocale);
  const referencesQuery = useSuspenseInfiniteQuery({
    queryKey: ['references'],
    queryFn: async ({ pageParam = 1 }) => {
      return await fetchReferences({
        locale,
        query: {
          page: pageParam,
          results: 3,
        },
      });
    },
    getNextPageParam: (lastPage: any, pages) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const references = referencesQuery.data?.pages.flatMap((page: any) => page.data) ?? [];
  const { t } = useTranslations();

  return (
    <Container className={cn('', 'ea-reference-page__wrapper')}>
      {references?.map(reference => (
        <div
          key={reference?.slug}
          className={cn('group transition', 'ea-reference-page__reference-card')}
        >
          <div className={cn('', 'ea-reference-page__reference-image-box')}>
            <ReferenceCardHover reference={reference} />
            <Image
              src={reference?.image?.url}
              alt={resolveImageAlt(reference?.image, reference?.name)}
              fill
              style={{ objectFit: 'cover', objectPosition: 'center' }}
              sizes="50vw"
            />
          </div>
          <h3 className={cn('group', 'ea-reference-page__reference-name')}>{reference?.name}</h3>
        </div>
      ))}
      <div className={cn('', 'ea-reference-page__button-box')}>
        <Button
          onClick={() => referencesQuery.fetchNextPage()}
          isLoading={referencesQuery.isFetchingNextPage}
          variant={'secondary'}
        >
          {t('text793')}
        </Button>
      </div>
    </Container>
  );
};
